export const featuredPortfolio = {
  name: "Aarush Shah",
  initials: "AS",
  location: "Mumbai, India · West Lafayette, Indiana",
  website: "https://aarushs.com",
  assets: {
    portfolio: "/assets/landing/aarush-portfolio-home.png",
    portrait: "/assets/landing/aarush-portrait.webp",
    resumePreview: "/assets/landing/aarush-shah-ats-resume-page-1.png",
  },
  identity: {
    role: "Mechanical Engineering Student & Researcher",
    focus: "Energy Systems, Applied Mathematics & Experimental Physics",
    edge: "Derives First. Builds Next. Validates Always.",
    promise: "Turns theoretical physics into measurable, working systems.",
    quote: "I derive the governing physics, model it mathematically, and validate it experimentally.",
    proof: "Published research · Propulsion · Computational modeling · Hands-on prototypes",
  },
  resume: {
    eyebrow: "Engineering and research",
    title: "Aarush Shah",
    subtitle: "Mechanical Engineering Student · Applied Mathematics",
    summary: "Purdue engineering student using first-principles mathematics, computational models, and experiments to solve energy and mechanical systems problems.",
    highlights: [
      "Published bioluminescent photovoltaic research",
      "Purdue Space Program propulsion team",
      "Python modeling, thermodynamics, and prototyping",
    ],
    href: "/assets/landing/aarush-shah-ats-resume.pdf",
  },
  linkedin: {
    eyebrow: "Student positioning",
    headline: "Mechanical Engineering Student at Purdue | Applied Mathematics | Energy Systems Research | Propulsion & Experimental Modeling",
    about: "I explore engineering problems from first principles: derive the governing physics, build the mathematical model, and validate it through experiments or simulation. My work spans photovoltaic energy harvesting, underwater electromagnetics, nonlinear vibration analysis, propulsion, and embedded prototypes.",
    current: "Studying mechanical engineering at Purdue and contributing to the Purdue Space Program propulsion team.",
    highlights: [
      "Energy systems and photovoltaic research",
      "Numerical modeling with Python and RK4",
      "Experimental design and rapid prototyping",
    ],
    href: "/assets/landing/aarush-linkedin-profile.html",
  },
  sop: {
    eyebrow: "Graduate-study narrative",
    title: "Where Theory Becomes Reality",
    body: "A statement connecting Aarush’s first-principles approach, energy research, propulsion work, and experimental practice to advanced study in mechanical engineering.",
    highlights: [
      "Foundation: applied mathematics and physics",
      "Evidence: research, simulation, and prototypes",
      "Direction: energy systems and computational engineering",
    ],
    href: "/assets/landing/aarush-statement-of-purpose.html",
  },
  identitySpec: {
    eyebrow: "Role · Focus · Edge",
    title: "Mechanical Engineering Student & Researcher",
    body: "A first-principles engineer who moves fluently from equations to simulations, experiments, and working prototypes.",
    highlights: [
      "Focus: energy systems and computational mechanics",
      "Edge: mathematical rigor plus experimental validation",
      "Proof: published research and multidisciplinary builds",
    ],
    href: "/assets/landing/aarush-identity-spec.html",
  },
  evidence: [
    {
      type: "Published research",
      title: "Bioluminescent Photovoltaic Energy Harvesting",
      body: "Modeled low-light photovoltaic performance, built an experimental apparatus, and compared theoretical predictions with measured power output.",
      tags: "Photovoltaics · Spectral analysis · Experimental design",
    },
    {
      type: "Advanced research",
      title: "Underwater Electromagnetic Communication",
      body: "Modified classical field equations for conductive seawater and simulated three-dimensional field distribution and signal attenuation in Python.",
      tags: "Vector calculus · Biot-Savart · Python simulation",
    },
  ],
};
